/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Nav_OtherInputs */

const id_nav_other = /** @type {(inputs: Nav_OtherInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lainnya`)
};

const ms_nav_other = /** @type {(inputs: Nav_OtherInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lain`)
};

const da_nav_other = /** @type {(inputs: Nav_OtherInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Andet`)
};

const de_nav_other = /** @type {(inputs: Nav_OtherInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sonstiges`)
};

const en_us2_nav_other = /** @type {(inputs: Nav_OtherInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Other`)
};

const es_es2_nav_other = /** @type {(inputs: Nav_OtherInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Otro`)
};

const es_mx2_nav_other = /** @type {(inputs: Nav_OtherInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Otro`)
};

const fil_nav_other = /** @type {(inputs: Nav_OtherInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Iba`)
};

const fr_nav_other = /** @type {(inputs: Nav_OtherInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Autre`)
};

const it_nav_other = /** @type {(inputs: Nav_OtherInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Altro`)
};

const hu_nav_other = /** @type {(inputs: Nav_OtherInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Egyéb`)
};

const nl_nav_other = /** @type {(inputs: Nav_OtherInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Anders`)
};

const no_nav_other = /** @type {(inputs: Nav_OtherInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Annet`)
};

const pl_nav_other = /** @type {(inputs: Nav_OtherInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Inny`)
};

const pt_br2_nav_other = /** @type {(inputs: Nav_OtherInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Outro`)
};

const pt_nav_other = /** @type {(inputs: Nav_OtherInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Outro`)
};

const ro_nav_other = /** @type {(inputs: Nav_OtherInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Altul`)
};

const fi_nav_other = /** @type {(inputs: Nav_OtherInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Muu`)
};

const sv_nav_other = /** @type {(inputs: Nav_OtherInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Annan`)
};

const vi_nav_other = /** @type {(inputs: Nav_OtherInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Khác`)
};

const tr_nav_other = /** @type {(inputs: Nav_OtherInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Diğer`)
};

const cs_nav_other = /** @type {(inputs: Nav_OtherInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ostatní`)
};

const bg_nav_other = /** @type {(inputs: Nav_OtherInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Други`)
};

const ru_nav_other = /** @type {(inputs: Nav_OtherInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Другое`)
};

const uk_nav_other = /** @type {(inputs: Nav_OtherInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Інший`)
};

const ar_nav_other = /** @type {(inputs: Nav_OtherInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`أخرى`)
};

const hi_nav_other = /** @type {(inputs: Nav_OtherInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`अन्य`)
};

const th_nav_other = /** @type {(inputs: Nav_OtherInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`อื่น ๆ`)
};

const ja_nav_other = /** @type {(inputs: Nav_OtherInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`その他`)
};

const zh_cn2_nav_other = /** @type {(inputs: Nav_OtherInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`其他`)
};

const zh_hant1_nav_other = /** @type {(inputs: Nav_OtherInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`其他`)
};

const ko_nav_other = /** @type {(inputs: Nav_OtherInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`기타`)
};

/**
* | output |
* | --- |
* | "Other" |
*
* @param {Nav_OtherInputs} inputs
* @param {{ locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }} options
* @returns {LocalizedString}
*/
const nav_other = /** @type {((inputs?: Nav_OtherInputs, options?: { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Nav_OtherInputs, { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_nav_other(inputs)
	if (locale === "ms") return ms_nav_other(inputs)
	if (locale === "da") return da_nav_other(inputs)
	if (locale === "de") return de_nav_other(inputs)
	if (locale === "en-US") return en_us2_nav_other(inputs)
	if (locale === "es-ES") return es_es2_nav_other(inputs)
	if (locale === "es-MX") return es_mx2_nav_other(inputs)
	if (locale === "fil") return fil_nav_other(inputs)
	if (locale === "fr") return fr_nav_other(inputs)
	if (locale === "it") return it_nav_other(inputs)
	if (locale === "hu") return hu_nav_other(inputs)
	if (locale === "nl") return nl_nav_other(inputs)
	if (locale === "no") return no_nav_other(inputs)
	if (locale === "pl") return pl_nav_other(inputs)
	if (locale === "pt-BR") return pt_br2_nav_other(inputs)
	if (locale === "pt") return pt_nav_other(inputs)
	if (locale === "ro") return ro_nav_other(inputs)
	if (locale === "fi") return fi_nav_other(inputs)
	if (locale === "sv") return sv_nav_other(inputs)
	if (locale === "vi") return vi_nav_other(inputs)
	if (locale === "tr") return tr_nav_other(inputs)
	if (locale === "cs") return cs_nav_other(inputs)
	if (locale === "bg") return bg_nav_other(inputs)
	if (locale === "ru") return ru_nav_other(inputs)
	if (locale === "uk") return uk_nav_other(inputs)
	if (locale === "ar") return ar_nav_other(inputs)
	if (locale === "hi") return hi_nav_other(inputs)
	if (locale === "th") return th_nav_other(inputs)
	if (locale === "ja") return ja_nav_other(inputs)
	if (locale === "zh-CN") return zh_cn2_nav_other(inputs)
	if (locale === "zh-Hant") return zh_hant1_nav_other(inputs)
	return ko_nav_other(inputs)
});
export { nav_other as "nav.other" }